import { onlyView } from '@/utils/onlyView.js'

let defaultState = {};
for (const key in onlyView) {
    if (Object.hasOwnProperty.call(onlyView, key)) {
         defaultState[key+'Random'] = ''
    }
}
export default {
    namespaced: true, //当前模块是否使用命名空间
    state:defaultState,
    // state: {
    //     cartRandom: '', // 购物车页面随机值
    //     billsCPRandom: '', // 订单页面随机值
    //     generateOrderDetailRandom: '',// 订单详情页面随机值
    //     generateOrder2DetailRandom: '',// 订单详情页面随机值2
    //     packOrderRandom: '', //     打包单随机值
    //     addEditPackOrderRandom: '', // 打包单详情随机值
    //     giftOrderRandom: '', // 礼品单详情随机值
    //     materialObjectRandom: '', // 退货单有实物随机值
    //     noMaterialObjectRandom: '', // 退货单有无实物随机值
    // },
    mutations: {
        setRandomLocalstorage(state, data) {
            // console.log('Object.keys(state)', Object.keys(state));
            for (let keyD of Object.keys(data)) {
                // console.log('keyD', keyD);
                for (let keyS of Object.keys(state)) {
                    if (keyS == keyD) {
                        // console.log('keyS keyD', keyS, keyD);
                        state[keyS] = data[keyD]
                    }
                }
            }
        },
    },
    getters: {},
    actions: {
        // 分发注册全局事件
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/randomLocalstorage.js